// libs
import React from "react";

// defs
import { SEVERITY } from "@defs/Severity";
import { IAlertPosition } from "@defs/Alert";

// components
import { Alert as MuiAlert, Snackbar as MuiSnackbar, SnackbarOrigin } from "@mui/material";

// icons
import { CheckCircleOutlined, ErrorOutline, WarningAmberOutlined, InfoOutlined } from "@mui/icons-material";

// props
export interface ISnackBarProps {
    title: string;
    severity: SEVERITY;
    isDismissible?: boolean;
    autoTimeout?: number;
    alertPosition?: IAlertPosition;
    onClose?: () => void;
}

const SnackBar: React.FC<ISnackBarProps> = ({
    title,
    severity,
    autoTimeout,
    alertPosition = { vertical: "bottom", horizontal: "right" },
    onClose = () => {},
}) => {
    const getIconBySeverity = (): React.ReactElement | undefined => {
        switch (severity) {
            case SEVERITY.SUCCESS:
                return <CheckCircleOutlined />;
            case SEVERITY.ERROR:
                return <ErrorOutline />;
            case SEVERITY.WARNING:
                return <WarningAmberOutlined />;
            case SEVERITY.INFO:
                return <InfoOutlined />;
            default:
                return undefined;
        }
    };

    return (
        <MuiSnackbar
            anchorOrigin={{ vertical: alertPosition.vertical, horizontal: alertPosition.horizontal } as SnackbarOrigin}
            autoHideDuration={autoTimeout}
            open={true}
            onClose={onClose}
            key={title}>
            <MuiAlert severity={severity} variant="standard" sx={{ width: "100%" }} icon={getIconBySeverity()}>
                {title}
            </MuiAlert>
        </MuiSnackbar>
    );
};

export default React.memo(SnackBar);
